import React, { useEffect, useState } from "react";
import axios from "axios";
import EditUser from "./ProfileEdit";
import noProfilePic from "../../assets/img/auth/noProfilePic.avif";

const UserProfile = () => {
  const localUserData = JSON.parse(
    localStorage.getItem("Ananya Enterprize-Users-Data")
  );
  const [uData, setUData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [editProgfileOpen, setEditProfileOpen] = useState(false);

  useEffect(() => {
    getUsersData();
  }, []);

  const getUsersData = () => {
    let resquestUrl;
    if (localUserData?.role == "admin" || localUserData?.role == "staff") {
      resquestUrl = `${process.env.REACT_APP_API_URL}/user/get-user-by-id/${localUserData?._id}`;
    }

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: resquestUrl,
      headers: {},
    };

    setIsLoading(true);
    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        setUData(response.data.user);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  console.log("------uData------>", uData);

  return (
    <div className="mx-auto mt-6 rounded-lg bg-white p-6 shadow-lg">
      {isLoading ? (
        <div className="animate-pulse">
          <div className="flex flex-col items-center justify-between border-b border-gray-200 pb-6 md:flex-row">
            <div className="flex flex-col items-center  space-x-6 md:flex-row">
              <div className="h-24 w-24 rounded-full bg-gray-300"></div>
              <div>
                <div className="mb-2 h-8 w-48 rounded bg-gray-300"></div>
                <div className="mb-2 h-6 w-36  rounded bg-gray-300 text-center md:text-start"></div>
                <div className="h-6 w-24 rounded  bg-gray-300 text-center md:text-start"></div>
              </div>
            </div>
            <div className="mt-4 h-10 w-32 rounded bg-gray-300 md:mt-0"></div>
          </div>
          <div className="py-6">
            <div className="mb-4 h-6 w-32 rounded bg-gray-300"></div>
            <div className="mb-2 h-4 rounded bg-gray-300"></div>
            <div className="mb-2 h-4 rounded bg-gray-300"></div>
            <div className="mb-2 h-4 rounded bg-gray-300"></div>
            <div className="h-4 rounded bg-gray-300"></div>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {Array(6)
              .fill()
              .map((_, i) => (
                <div key={i} className="rounded-lg bg-gray-100 p-4 shadow-sm">
                  <div className="mb-2 h-4 w-20 rounded bg-gray-300"></div>
                  <div className="h-4 w-36 rounded bg-gray-300"></div>
                </div>
              ))}
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-col items-center justify-between border-b border-gray-200 pb-6 md:flex-row">
            <div className="flex flex-col items-center justify-center space-x-6 overflow-x-auto md:flex-row">
              <img
                src={uData?.profilePic || noProfilePic}
                alt="Profile"
                className="h-24 w-24 rounded-full border-4 border-primary object-cover shadow-lg"
              />
              <div className="">
                <h2 className="my-2 text-center text-xl font-bold capitalize tracking-wider text-[#070619] md:text-start md:text-3xl">
                  {uData?.name}
                </h2>
                <p className="text-md hidden text-center tracking-wide text-gray-600 md:block md:text-start">
                  {uData?.email}
                </p>
                <p className="mt-1 text-center capitalize tracking-wide text-[#640708] md:text-start">
                  {/* - {uData?.role || "Branch Admin"} - */}
                </p>
              </div>
            </div>
            <button
              onClick={() => {
                setEditProfileOpen(true);
              }}
              className="mt-4 rounded-lg bg-gradient-to-r from-blue-100 to-primary px-6 py-3 text-sm font-semibold tracking-wider text-white transition duration-300 ease-in-out md:mt-0"
            >
              Edit Profile
            </button>
          </div>

          <div className="grid grid-cols-1 gap-6 tracking-wide sm:grid-cols-2">
            <div className="overflow-x-auto rounded-lg bg-blue-100 p-4 shadow-sm">
              <h4 className="text-sm font-medium text-[#070619]">Email</h4>
              <p className="mt-1 text-gray-700">{uData?.email}</p>
            </div>
            <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
              <h4 className="text-sm font-medium text-[#070619]">Phone</h4>
              <p className="mt-1 text-gray-700">{uData?.phone}</p>
            </div>

            {localUserData?.role === "admin" && (
              <>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">Gender</h4>
                  <p className="mt-1 text-gray-700">{uData?.gender}</p>
                </div>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">
                    Date Of Birth
                  </h4>
                  <p className="mt-1 text-gray-700">
                    {uData?.dateOfBirth?.substring(0, 10)}
                  </p>
                </div>
              </>
            )}
            {localUserData?.role === "staff" && (
              <>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">Gender</h4>
                  <p className="mt-1 text-gray-700">{uData?.gender}</p>
                </div>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">
                    Date Of Birth
                  </h4>
                  <p className="mt-1 text-gray-700">
                    {uData?.dateOfBirth?.substring(0, 10)}
                  </p>
                </div>
              </>
            )}

            {localUserData.role == "admin" && (
              <>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">
                    Nationality
                  </h4>
                  <p className="mt-1 text-gray-700">{uData?.nationality}</p>
                </div>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">
                    Address
                  </h4>
                  <p className="mt-1 text-gray-700">{uData?.address}</p>
                </div>
              </>
            )}
            {localUserData.role == "staff" && (
              <>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">
                    Nationality
                  </h4>
                  <p className="mt-1 text-gray-700">{uData?.nationality}</p>
                </div>
                <div className="rounded-lg bg-blue-100 p-4 shadow-sm">
                  <h4 className="text-sm font-medium text-[#070619]">
                    Address
                  </h4>
                  <p className="mt-1 text-gray-700">{uData?.address}</p>
                </div>
              </>
            )}
          </div>
        </>
      )}
      {editProgfileOpen && (
        <EditUser
          onClose={() => setEditProfileOpen(false)}
          userData={uData}
          getUserData={getUsersData}
        />
      )}
    </div>
  );
};

export default UserProfile;
